import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { processSteps } from "@/mocks/siteData";

export default function ProcessSteps() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-100">
      <div className="max-w-content mx-auto">
        <Reveal>
          <SectionHeading
            eyebrow="投稿流程"
            title="从提交到跟进，一共四步"
            desc="每一步都围绕同一件事设计：在尽量少暴露你的前提下，把线索核实清楚。"
            align="center"
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {processSteps.map((step, index) => (
            <Reveal key={step.id} delay={index * 90}>
              <div className="relative h-full p-6 rounded-lg bg-background-50 border border-background-200">
                <div className="flex items-center justify-between">
                  <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-700 text-xl">
                    <i className={step.icon}></i>
                  </span>
                  <span className="font-heading text-2xl font-bold text-background-400">
                    {step.step}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">
                  {step.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}